import {jsx} from 'panel';

import {ActionsPopoverEl} from 'common/widgets/actions-popover';
import {SvgIconEl} from 'common/components/svg-icon';
import type {PopoverParams} from 'common/report/funnels/visualization/chart-display';

export function StepsChartPopover({popoverParams}: {popoverParams: PopoverParams}) {
  if (!popoverParams.open) {
    return null;
  }
  return (
    <ActionsPopoverEl
      sel='.action-popover'
      attrs={{
        open: popoverParams.open,
        title: popoverParams.title,
        'button-options': popoverParams.buttonOptions,
        'is-segmented': popoverParams.isSegmented,
        'prevent-close-selectors': [`div.bar`, `div.drop-off-bar`],
      }}
      style={popoverParams.styles}
      on={{
        action: popoverParams.onAction,
        close: popoverParams.onClose,
      }}
    >
      <div>
        <div sel='.popover-content-wrapper'>
          {popoverParams.slottedContent?.map((content) => (
            <div sel='.popover-content-row'>
              <div sel='.popover-content-icon'>
                {popoverParams.isDropOff ? (
                  <div sel='.drop-off-icon'>
                    <SvgIconEl attrs={{icon: `circle-decrease`}} />
                  </div>
                ) : (
                  <div sel='.community-icon'>
                    <SvgIconEl attrs={{icon: `community`}} />
                  </div>
                )}
              </div>
              <div sel='.popover-content-text-wrapper'>
                <div sel='.popover-slot'>
                  <div sel='.popover-content-text'>{content.text}</div>
                  {content.subTextLines.map((line) => (
                    <div sel='.popover-content-subtext'>{line}</div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ActionsPopoverEl>
  );
}
